import { toastController } from '@ionic/vue';

export const showToast = async (message, duration = 1500) => {
  const toast = await toastController.create({
    message,
    duration
  });
  await toast.present();
};
